// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { initialize } from 'redux-form'
import { push } from 'react-router-redux'
import setCurrentEntity from './setCurrentEntity'

const updateEntityDetails = entityId => async (dispatch, getState) => {
  const {
    databaseDetails,
    form,
  } = getState()

  const dbSet = databaseDetails.get('dbSet')
  const isNewEntity = databaseDetails.get('isNewEntity')

  if (isNewEntity) {
    const sourceForm = databaseDetails.get('sourceForm')
    const { values } = form[sourceForm]
    await dispatch(initialize(sourceForm, values))
    return dispatch(push(`/database-management/${dbSet}/${entityId}`))
  }

  return dispatch(setCurrentEntity(dbSet, entityId))
}

export default updateEntityDetails
